export const NOTIFICATION_BAR_DATA = [
  {
    code: 'account.message.wishlistAdd',
    message: null,
    description: 'This item has been added to your Wishlist',
    xsTitleButton: 'View',
    titleButton: 'View wishlist',
    handleClickData: '/account/wishlists',
  },
  {
    code: 'account.message.registered',
    message: '',
    description: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: null,
  },
  {
    code: 'account.message.wishlistRemove',
    message: 'Product removed from Wishlist',
    xsTitleButton: 'View',
    titleButton: 'View wishlist',
    handleClickData: '/account/wishlists',
  },
  {
    code: 'account.message.passwordUpdate',
    message: 'Password updated',
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.passwordUpdateError',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.addressUpdated',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.addressRemoved.error',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.addressNew',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.addressRemoved',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.update',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'account.message.logout',
    message: 'You have successfully logged out of your account',
    xsTitleButton: null,
    titleButton: null,
    handleClickData: null,
  },
  {
    code: 'commercetools.InvalidCurrentPassword',
    message: null,
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/account/profile',
  },
  {
    code: 'commercetools.MatchingPriceNotFound',
    message: 'Oops... Failed to add item to cart',
    xsTitleButton: null,
    titleButton: null,
    handleClickData: '/product',
  },
  {
    code: 'product.giftCard.add.error',
    message: '',
    xsTitleButton: null,
    titleButton: null,
    handleClickData: null,
  },
];

export const NOTIFICATION_EXCLUDES = [
  'Unknown',
  'account.message.cartAdd',
  'account.message.resetFail',
  'symfony.invalid',
  'account.message.reset',
  // 'account.message.passwordUpdate',
  'commercetools.',
];
